import type { DateRepresentation } from '../DateRepresentation';
import { defaultTimeZone } from '../defaultTimeZone';
import { formatInTz } from '../format/formatEST';
import { startOfDayInTZ } from '../startOfDay';

/**
 * Return true if dateA is after dateB
 *
 * @param dateA
 * @param dateB
 * @returns
 */
export function isSameYearInTZ(
	dateA: DateRepresentation,
	dateB?: DateRepresentation,
	timeZone: string = defaultTimeZone,
): boolean {
	const dateValueA = startOfDayInTZ(dateA, timeZone);
	if (!dateValueA) {
		return false;
	}

	const dateValueB = startOfDayInTZ(dateB ?? new Date(), timeZone);
	if (!dateValueB) {
		return false;
	}

	const dateStringA = formatInTz(dateValueA, 'yyyy', undefined, timeZone);
	const dateStringB = formatInTz(dateValueB, 'yyyy', undefined, timeZone);

	return dateStringA === dateStringB;
}
